/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Path } from 'react-router-dom';
import { queryToSearchString } from '~shared/helpers/query';
import { RawQuery } from '~shared/types/router';

export const ARCHITECTURE_ROUTE_NAME = 'architecture';
export const DISCOVERY_ROUTE_NAME = 'discovery';
export const TANGLES_ROUTE_NAME = 'tangles';
export const OVERSIZE_ROUTE_NAME = 'oversize';
export const MODEL_ROUTE_NAME = 'model';
export const MODEL_VISUAL_ROUTE_NAME = `${MODEL_ROUTE_NAME}/visual`;
export const DISALLOWED_DEPENDENCIES_ROUTE_NAME = 'disallowed-dependencies';
export const MISPLACED_COMPONENTS_ROUTE_NAME = 'misplaced-components';

export const ARCHITECTURE_DASHBOARD_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}`;
export const ARCHITECTURE_DISCOVERY_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${DISCOVERY_ROUTE_NAME}`;
export const ARCHITECTURE_TANGLES_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${TANGLES_ROUTE_NAME}`;
export const ARCHITECTURE_OVERSIZE_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${OVERSIZE_ROUTE_NAME}`;
export const ARCHITECTURE_MODEL_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${MODEL_ROUTE_NAME}`;
export const ARCHITECTURE_MODEL_VISUAL_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${MODEL_VISUAL_ROUTE_NAME}`;
export const ARCHITECTURE_DISALLOWED_DEPENDENCIES_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${DISALLOWED_DEPENDENCIES_ROUTE_NAME}`;
export const ARCHITECTURE_MISPLACED_COMPONENTS_ROUTE_NAME = `${ARCHITECTURE_ROUTE_NAME}/${MISPLACED_COMPONENTS_ROUTE_NAME}`;

export const getArchitectureUrl = (
  componentKey: string,
  path: string,
  query?: RawQuery,
): Partial<Path> => {
  return {
    pathname: `/project/${path}`,
    search: queryToSearchString({ ...query, id: componentKey }),
    hash: '',
  };
};

export function architectureBreadcrumbs() {
  return {
    '/project/architecture': {
      showBranch: true,
    },
    '/project/architecture/discovery': {
      showBranch: true,
    },
    '/project/architecture/tangles': {
      showBranch: true,
    },
    '/project/architecture/oversize': {
      showBranch: true,
    },
    '/project/architecture/model': {
      showBranch: true,
    },
    '/project/architecture/model/visual': {
      showBranch: true,
    },
    '/project/architecture/disallowed-dependencies': {
      showBranch: true,
    },
    '/project/architecture/misplaced-components': {
      showBranch: true,
    },
  };
}
